import { getStats } from '@/shared/api/sol-api/collection';

export const useGetMECollectionStatsQuery = async (collectionSlug: string) => {
  return getStats(collectionSlug);
};
